import React from 'react';
import { Layout } from '../components/Layout';
import { Container } from '../components/ui/Container';
import { PricingCard } from '../components/PricingCard';
import { Link } from 'react-router-dom';
export function PricingPage() {
  return <Layout data-id="element-326">
      <div className="bg-slate-50 py-16 border-b border-slate-200" data-id="element-327">
        <Container className="text-center" data-id="element-328">
          <h1 className="text-4xl font-bold text-slate-900 mb-6" data-id="element-329">
            Transparent Pricing
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-330">
            Clear, flat-rate pricing for our consulting services. No hidden
            fees, no long-term contracts, and no performance-based commissions.
          </p>
        </Container>
      </div>

      <Container className="py-20" data-id="element-331">
        {/* Monthly Plans Section */}
        <div className="mb-16" data-id="element-332">
          <div className="text-center mb-12" data-id="element-333">
            <h2 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-334">
              Monthly Consulting Plans
            </h2>
            <p className="text-slate-600" data-id="element-335">
              Ongoing education and guidance with flexible monthly billing
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-336">
            <PricingCard title="Essential Credit Consulting" price="$119" billingType="month" description="Ongoing credit education and guidance to help you understand and improve your financial profile." features={['Ongoing credit education & guidance', 'Monthly credit profile review', 'Personalized action steps', 'Email / messaging support', 'Access to educational resources']} ctaText="Get Started – $119/month" isPopular={true} data-id="element-337" />

            <PricingCard title="Advanced Credit Strategy" price="$149" billingType="month" description="Comprehensive strategy planning with priority support and deeper analysis." features={['Everything in Essential', 'Deeper credit strategy planning', 'Priority support', 'Monthly strategy check-ins', 'Personalized utilization & habit guidance']} ctaText="Get Started – $149/month" data-id="element-338" />
          </div>
        </div>

        {/* One-Time Plans Section */}
        <div className="mb-16" data-id="element-339">
          <div className="text-center mb-12" data-id="element-340">
            <h2 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-341">
              One-Time Consulting Services
            </h2>
            <p className="text-slate-600" data-id="element-342">
              Comprehensive analysis and strategy with a single payment
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-343">
            <PricingCard title="Comprehensive Credit Review" price="$1,500" billingType="one-time" description="In-depth analysis with personalized strategy plan and consultation session." features={['One-time in-depth credit and financial profile analysis', 'Personalized written strategy plan', '1:1 consultation session', 'Clear next-step roadmap']} ctaText="Book One-Time Consultation" data-id="element-344" />

            <PricingCard title="Premium Credit Advisory" price="$2,000" billingType="one-time" description="Our most comprehensive service with extended advisory and follow-up support." features={['Everything in Comprehensive Review', 'Extended 1:1 advisory session', 'Advanced credit and financial planning guidance', 'Priority scheduling', 'Ongoing follow-up for a limited period']} ctaText="Apply for Premium Advisory" data-id="element-345" />
          </div>
        </div>

        {/* Compliance Disclaimer */}
        <div className="mt-16 bg-amber-50 rounded-xl p-8 border border-amber-200 max-w-4xl mx-auto" data-id="element-346">
          <h3 className="text-lg font-bold text-amber-900 mb-3" data-id="element-347">
            Important Disclaimer
          </h3>
          <p className="text-amber-900 text-sm leading-relaxed mb-4" data-id="element-348">
            DanyCredit provides educational and consulting services only. We do
            not guarantee credit score increases, approvals, or financial
            outcomes. Results vary by individual profile.
          </p>
          <p className="text-amber-800 text-sm leading-relaxed" data-id="element-349">
            All fees are for professional time and expertise of our consultants.
            We do not charge fees based on the outcome of any dispute or credit
            score change. We do not collect fees for "credit repair" services as
            defined by federal law.
          </p>
        </div>

        {/* Legal Links */}
        <div className="mt-8 text-center" data-id="element-350">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-600" data-id="element-351">
            <Link to="/privacy-policy" className="hover:text-blue-600 transition-colors" data-id="element-352">
              Privacy Policy
            </Link>
            <span className="text-slate-400" data-id="element-353">|</span>
            <Link to="/terms-and-conditions" className="hover:text-blue-600 transition-colors" data-id="element-354">
              Terms & Conditions
            </Link>
            <span className="text-slate-400" data-id="element-355">|</span>
            <Link to="/refund-policy" className="hover:text-blue-600 transition-colors" data-id="element-356">
              Refund Policy
            </Link>
          </div>
        </div>
      </Container>
    </Layout>;
}